import React from 'react';
import {useQuery} from 'react-query';
import {getOrders} from '../../api/exchange';
import {getById} from '../../api';
import {IShopConfig} from '../../types/shop';
import {FlatList, ScrollView} from 'react-native';
import {OrderItem} from './orderitem';
export function OrdersPage(props: {shopId: string}) {
  const ordersQuery = useQuery('orders_' + props.shopId, async () => {
    const shopconfig = (await getById(props.shopId)) as IShopConfig;

    if (shopconfig?.address) {
      const orders = await getOrders(shopconfig.address);
      console.info('orders', orders);
      return orders;
    }

    return [];
  });
  const orders = ordersQuery.data || [];
  return (
    <ScrollView
      style={{width: '100%', backgroundColor: 'black'}}
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}>
      <FlatList
        data={orders}
        style={{backgroundColor: 'black'}}
        renderItem={p => (
          <OrderItem
            {...p}
            ordersQuery={ordersQuery}
            shopId={props.shopId}
          />
        )}
      />
    </ScrollView>
  );
}
